var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropdownIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 14.569C11.2923 15.168 10.4134 15.168 10.0182 14.569L6.10259 8.63473C5.66389 7.96987 6.14072 7.08398 6.93726 7.08398L14.7685 7.08399C15.565 7.08399 16.0418 7.96987 15.6031 8.63473L11.6875 14.569Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIc);
export default __webpack_public_path__ + "static/media/dropdown-ic.b57edcbf77cd3f344c1d06c0df467ea5.svg";
export { ForwardRef as ReactComponent };